import React, {useState} from 'react'
import styled from 'styled-components';
import JoinClubHeader from './components/JoinClubHeader/JoinClubHeader';

const StyledApp = styled.div`
background: #fefefe;
box-sizing: border-box;
margin: auto;
padding: 0;
height: auto;

.nav{
  width: 100%;
  max-width: 100vw;
  height: 75px;
  background: #222;
}
.nav>.logo  {
  color: white;
  text-transform: uppercase;
  display: flex;

}
`;

const App = () => {

  
  return (
    <StyledApp>
      <div className="nav"></div>
      <JoinClubHeader />

    </StyledApp>

    
    

  )
}

export default App